export default {
  load(data) {
    return env.API.post('pdf/getPdf', data);
  },
  deletePdf(id) {
    return env.API.post('pdf/delete', {id: id});
  },
}
